export default __webpack_public_path__ + "img/fxtVpZTi.b9cb2371.svg";